import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '@card-software/library';
import { ExternalRequisitionStatus } from '../../models/order/external-requisition/external-requisition-status';

@Injectable({
  providedIn: 'root',
})
export class ExternalRequisitionStatusProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.orderApi + '/api/v1/external-requisition-status';

  public getAll(): Observable<ApiResponse<ExternalRequisitionStatus[]>> {
    return this.httpClient.get<ApiResponse<ExternalRequisitionStatus[]>>(`${this.baseUrl}/all`);
  }
}
